// extracted by mini-css-extract-plugin
module.exports = {"PowerTechnology":"PowerTechnology_PowerTechnology__6cIVJ"};